function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "camera"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m6 9c-.26 0-.52.11-.71.291-.181.192-.29.453-.29.715s.109.522.29.715c.38.372 1.04.372 1.42 0 .18-.193.29-.453.29-.715s-.11-.523-.29-.715c-.19-.181-.45-.291-.71-.291z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19 6h-2.382l-.724-1.447c-.169-.339-.515-.553-.894-.553h-6c-.379 0-.725.214-.895.553l-.723 1.447h-2.382c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm1 11c0 .552-.449 1-1 1h-14c-.551 0-1-.448-1-1v-8c0-.552.449-1 1-1h3c.379 0 .725-.214.895-.553l.723-1.447h4.764l.724 1.447c.169.339.515.553.894.553h3c.551 0 1 .448 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 9c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
})));

var Svg009Camera = function Svg009Camera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg009Camera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/009-camera.77a4979a.svg";
export { ForwardRef as ReactComponent };